import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../../Button'
import { Checkbox } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormBody, FormFieldsContainer } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldErrorProps,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import { PasswordInput } from '../../../../Input'
import { AuthLicense } from '../../../AuthLicense'
import {
  CREATE_PASSWORD_FORM_FIELD_HEIGHT,
  CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES,
  CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD,
  CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD,
  CREATE_PASSWORD_FORM_PASSWORD_MAX_LENGTH,
} from '../CreatePasswordForm.constants'
import { useValidationErrorsNotification } from '../CreatePasswordForm.hooks'
import { CreatePasswordFormRequirements } from '../CreatePasswordFormRequirements'

import { getPasswordInputErrorProps } from './CreatePasswordFormFields.utils'

import * as styles from './CreatePasswordFormFields.module.css'

function CreatePasswordFormFields({ onRemoveNotification, onSetNotification }) {
  const { errors, isSubmitting } = useFormikContext()

  const { t } = useTranslation()

  useValidationErrorsNotification({
    errors,
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody Actions={null} Header={null}>
      <FormFieldsContainer className={styles.formFields}>
        <FormikField
          Component={PasswordInput}
          Field={FieldStackedLabel}
          disabled={isSubmitting}
          getErrorProps={getPasswordInputErrorProps}
          height={CREATE_PASSWORD_FORM_FIELD_HEIGHT}
          label={t('Auth.CreatePasswordPasswordLabelKey')}
          maxLength={CREATE_PASSWORD_FORM_PASSWORD_MAX_LENGTH}
          name={CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD}
          placeholder={t('Auth.CreatePasswordPasswordPlaceholderKey')}
        />
        <FormikField
          Component={PasswordInput}
          Field={FieldStackedLabel}
          disabled={isSubmitting}
          getErrorProps={getPasswordInputErrorProps}
          height={CREATE_PASSWORD_FORM_FIELD_HEIGHT}
          label={t('Auth.CreatePasswordRepeatPasswordLabelKey')}
          maxLength={CREATE_PASSWORD_FORM_PASSWORD_MAX_LENGTH}
          name={CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD}
          placeholder={t('Auth.CreatePasswordRepeatPasswordPlaceholderKey')}
        />
        <CreatePasswordFormRequirements />
        <FormikField
          Component={Checkbox}
          Field={Fragment}
          className={styles.rulesCheckbox}
          getErrorProps={getFormikCheckboxFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={<AuthLicense text='Auth.CreatePasswordAcceptRulesKey' />}
          name={CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES}
        />
      </FormFieldsContainer>
      <Button.Contained
        className={styles.button}
        height={CREATE_PASSWORD_FORM_FIELD_HEIGHT}
        isLoading={isSubmitting}
        text={t('Auth.CreatePasswordSubmitBtnKey')}
        type='submit'
      />
    </FormBody>
  )
}

export default CreatePasswordFormFields
